import { render, staticRenderFns } from "./flowCustomerInformation.vue?vue&type=template&id=052290ac&scoped=true"
import script from "./flowCustomerInformation.vue?vue&type=script&lang=js"
export * from "./flowCustomerInformation.vue?vue&type=script&lang=js"
import style0 from "./flowCustomerInformation.vue?vue&type=style&index=0&id=052290ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052290ac",
  null
  
)

export default component.exports